export default [
  {
    question: 'What is a cease request?',
    answer: [
      'A cease request is a request to stop (cease) a live service.',
    ],
  },
  {
    question: 'What is a cease quote?',
    answer: [
      'A cease quote is a request for Neos to provide guidance on any Early Termination Fees (ETF’s) that might be applied as the service is within the minimum contract term specified in your contract.',
    ],
  },
  {
    question: 'Why can\'t I see the option to request a cease?',
    answer: [
      'Only authorised users can submit cease requests. To gain access rights, you will need to contact your company\'s LIVEQUOTE admin.',
    ],
  },
  {
    question: 'Can I bulk upload multiple cease requests in LIVEQUOTE?',
    answer: [
      'Although we can not currently support attachments in the portal, you can use the copy functionality where you can choose to leave all information the same, just add the unique IDN reference.  This means that you will receive a CEASE reference for each unique IDN immediately.',
    ],
  },
  {
    question: 'How much notice do I need to give?',
    answer: [
      'The minimum notice period for a cease request is 35 days’ for Contracts signed pre - 01/07/2026 and 45 days’ for Contracts signed post - 01/07/2026; the maximum notice period is 3 months. Cease quotes can be requested at any time.',
    ],
  },
  {
    question: 'What happens after I submit a cease request or Quote?',
    answer: [
      'The Neos Networks Cease team will be in touch within 48 hrs; the title of this communication will contain a cease reference (e.g. CEASE0001234) relating to your request.',
      'If your service is still in contract with Neos Networks a Cease quote will be provided which will advise you of any early termination fees (ETF\'s). We will only move forward with the request once you\'ve confirmed you\'d like us to proceed.',
    ],
  },
  {
    question: 'How do I cancel a cease request?',
    answer: [
      'Reply directly to any communications you have received from the Neos Networks Cease team as this will already contain the cease reference relating to your request.',
      'Please note once a cease is in-flight we cannot guarantee a cancellation is possible, especially with third parties.',
    ],
  },
  {
    question: 'How do I extend a cease request to a later date?',
    answer: [
      'Reply directly to any communications you have received from the Neos Networks Cease team as this will already contain the cease reference relating to your request.',
      'A minimum advanced notice of five business days prior to your agreed cease date is required should you wish to amend this request. Please note once a cease is in-flight, we cannot guarantee an extension is possible, especially with third parties. Furthermore, in some cases, additional charges may be payable.',
    ],
  },
  {
    question: 'For any questions on my cease who should I contact?',
    answer: [
      'Reply directly to any communications you have received from the Neos Networks Cease team as this will already contain the cease reference relating to your request.',
    ],
  },
];
